module.exports = __webpack_public_path__ + "media/images/svg/robles_factory-85e2ab5831f66cc0ca7e9cfdf76e3697.svg";